module.exports = __webpack_public_path__ + "img/hyu_gallery2.b4d64e51.jpg";